export default __webpack_public_path__ + "static/media/est-ensemble.f1e679d1.mp4";